import React , {useState} from 'react';
import PropTypes from 'prop-types';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import CardModal from '../layouts/CardModal';
import { Link } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';




Explore2.propTypes = {
    data : PropTypes.array,
};

function Explore2(props) {

    const {data} = props;

    const [modalShow, setModalShow] = useState(false);

    const [dataTab] = useState([
        {
            id: 1,
            title: 'SHOPPING',
            item: 0,
        },
        {
            id: 2,
            title: 'ENTERTAINMENT',
            item: 4,
        },
        {
            id: 3,
            title: 'GAMING',
            item: 2,
        },
        {
            id: 4,
            title: 'TRAVELS',
            item: 6,
        },
        {
            id: 5,
            title: 'FASHION',
            item: 7,
        },
        {
            id: 6,
            title: 'ELECTRONICS',
            item: 1,
        },
        {
            id: 7,
            title: 'LIFESTYLE',
            item: 3,
        },

    ]);
    return (
        <section className="tf-section tf-explore tf-filter tf-center">
                <div className="tf-container">
                    <div className="row ">
                        <div className="col-md-12">
                            <div className="tf-heading style-2 wow fadeInUp">
                                <h4 className="heading">Browse Vouchers</h4>
                            </div>
                        </div>
                        <div className="col-md-12">
                        <Tabs>
                        <div className="d-flex justify-content-between mb-wr" style={{flexWrap: 'nowrap', alignItems: 'center', gap: '20px'}}>
                            <TabList style={{flex: '1', display: 'flex', flexWrap: 'wrap', margin: 0, gap: '15px'}}>
                                {
                                    dataTab.map(idx => (
                                        <Tab key={idx.id} style={{marginRight: '0'}}>{idx.title}</Tab>
                                    ))
                                }
                                
                            </TabList>

                            <Dropdown style={{flexShrink: 0}}>
                                    <Dropdown.Toggle id="dropdown-basic" className=''>
                                        Recently added    
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                    <Dropdown.Item href="#">
                                        <li><span>Recently Added</span></li>
                                    </Dropdown.Item>
                                    <Dropdown.Item href="#">
                                        <li className="active"><span>Most Popular</span></li>
                                    </Dropdown.Item>
                                    <Dropdown.Item href="#">
                                        <li><span>Best Deals</span></li>
                                    </Dropdown.Item>
                                    
                                    </Dropdown.Menu>
                            </Dropdown>
                        </div>
                            


                            {
                                dataTab.map(idx => (
                                    <TabPanel key={idx.id}>
                                        <div className="row tf-filter-container wow fadeInUp">
                                            {
                                                data.slice(idx.item, 8).map(idx => (
                                                    <div key={idx.id} className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-6 tf-loadmore 3d pixel">
                                                        <div className="sc-product style3">
                                                            <div className="features">
                                                                <div className="product-media">
                                                                    <img src={idx.img} alt="images" />
                                                                </div>
                                                            </div>
                                                            <div className="content" style={{
                                                                background: 'linear-gradient(to bottom, rgba(0,0,0,0.3), rgba(0,0,0,0.8))',
                                                                padding: '15px',
                                                                borderRadius: '0 0 8px 8px'
                                                            }}>
                                                                <div className="details-product">
                                                                    <div className="title"> <Link to="/item-details">{idx.title}</Link> </div>
                                                                    <div className="creator"> <Link to="#">{idx.create}</Link> </div>
                                                                </div>
                                                                <div className="price">
                                                                    <div className="subtitle">Price</div>
                                                                    <div className="cash">{idx.price}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        
                                        </div>
                                    </TabPanel>
                                ))
                            }
                            

                        </Tabs> 
                        </div>
                        <div className="col-md-12">
                            <div className="btn-loadmore mt8 wow fadeInUp">
                                <Link to="/explore" className="tf-button loadmore style-4">Load more</Link>
                            </div>
                        </div>
                    </div>


                </div>

                <CardModal 
                    show={modalShow}
                    onHide={() => setModalShow(false)} 
                />
        </section>
    );
}

export default Explore2;